import { render, staticRenderFns } from "./LegalRegulationsListComponent.vue?vue&type=template&id=1b4e2c5c&"
import script from "./LegalRegulationsListComponent.vue?vue&type=script&lang=js&"
export * from "./LegalRegulationsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports